/*
 * Copyright (c) 2022-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: SelectShapeControl.ts
 * Project: mle-client-n
 * Committed last: 2022/1/18 @ 1637
 * ---
 * Description:
 */

import { ShapeControl, ShapeControlInitParams } from './ControlGroup';
import { ControlTypes }                         from '../../selection-properties';

export interface SelectSCItem<T> {
  value: T;
  name?: string;
}

/**
 * Converte una serie di valori in un vettore di elementi selezionabili
 * @param values
 */
export const valuesToSelectItems = <T>(values: T[]): SelectSCItem<T>[] => {
  let items: SelectSCItem<T>[] = [];

  for (const v of values)
    items.push({
      value: v
    });

  return items;
};

export class SelectShapeControl extends ShapeControl<string> {
  public items?: SelectSCItem<any>[];

  constructor(initParams: ShapeControlInitParams<string>, { items }: { items: SelectSCItem<any>[] }) {
    super(initParams);
    this.items = items;
    this.controlType = ControlTypes.SELECT;
  }

  getItemAt<T>(index: number): SelectSCItem<T> | undefined {
    if (this.items)
      return this.items[index] as SelectSCItem<T>;
  }
}